import './Avatar.scss';

export default function Avatar({size}) {
	let sizePx = size ?? 50;
	return (
		<div className={"Avatar"} style={{ width: sizePx + 'px', height: sizePx + 'px'}} />
	);
}
